module.exports = __webpack_public_path__ + "static/media/value-absolute.97d651c3.svg";